import { render, staticRenderFns } from "./ElaborazioniBatchFilesPage.vue?vue&type=template&id=288a12f2"
import script from "./ElaborazioniBatchFilesPage.vue?vue&type=script&lang=js"
export * from "./ElaborazioniBatchFilesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports